export const PASSWORD=1;
export const SHIPPING=2;